import React, { useEffect, useState } from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';


const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const handlePaymentIntentStatus = (status) => {
    console.log({status})
    if (status === 'succeeded') {
      props.PaySucess();
      return;
    }
    if (status === 'processing' || status === 'requires_capture') {
      if (props.PayReceived) {
        props.PayReceived();
      } else {
        props.CloseModal();
      }
      return;
    }
    if (status === 'requires_payment_method' || status === 'canceled') {
      setErrorMessage('Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Bitte versuche es erneut.');
    }
    if (status === 'requires_action') {
      setErrorMessage('Der Zahlungsstatus ist unklar. Überprüfe in der App, ob die Zahlung erfolgt ist.');
    }
  };

  useEffect(() => {
    if (!stripe) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const clientSecret = params.get('payment_intent_client_secret');
    const redirectStatus = params.get('redirect_status');
    if (!clientSecret) {
      return;
    }

    const cleanUrl = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('payment_intent');
      url.searchParams.delete('payment_intent_client_secret');
      url.searchParams.delete('redirect_status');
      window.history.replaceState({}, '', url.toString());
    };

    // TWINT (and other async methods) return redirect_status=pending — retrieve
    // the actual PaymentIntent status before showing any confirmation, since a
    // cancelled TWINT payment also comes back as pending on redirect.
    // After smartphone confirmation the redirect can arrive ~20s before succeeded,
    // so we poll until the status resolves.
    if (redirectStatus === 'pending') {
      cleanUrl();
      setIsWaiting(true);
      const pollPaymentIntent = (attemptsLeft) => {
        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
          if (!paymentIntent) {
            setIsWaiting(false);
            setErrorMessage('Der Zahlungsstatus ist unklar. Überprüfe in der App, ob die Zahlung erfolgt ist.');
            return;
          }
          if (paymentIntent.status === 'requires_action' && attemptsLeft > 0) {
            setTimeout(() => pollPaymentIntent(attemptsLeft - 1), 3000);
            return;
          }
          setIsWaiting(false);
          handlePaymentIntentStatus(paymentIntent.status);
        });
      };
      pollPaymentIntent(10);
      return;
    }

    if (redirectStatus === 'failed') {
      cleanUrl();
      setErrorMessage('Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Bitte versuche es erneut.');
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      if (!paymentIntent) {
        return;
      }
      handlePaymentIntentStatus(paymentIntent.status);
      cleanUrl();
    });
  }, [stripe]);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsSubmitting(true);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.href },
      redirect: 'if_required',
    });
    setIsSubmitting(false);

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (e.g., payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      handlePaymentIntentStatus(paymentIntent ? paymentIntent.status : null);
    }
  };

  if (isWaiting) {
    return (
      <div className="text-center py-3">
        <div className="spinner-border d-block mx-auto" role="status">
          <span className="visually-hidden">Zahlung wird verarbeitet, bitte warten...</span>
        </div>
        <div className="text-muted mt-3">Zahlung wird verarbeitet, bitte warten...</div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement options={{disableLink: true}}/>
      <button className="btn btn-primary mt-3" disabled={!stripe || isSubmitting}>{"Jetzt CHF "+props.amount.toFixed(2)+" bezahlen"}</button>
      {/* Show error message to your customers */}
      {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
    </form>
  )
};

const StripeForm = (props) => {
  const pk = props.is_dev
    ?'pk_test_51LndsMJkFTRyFNmmgSwbe6gc6pfTQUPRQKkGeMpKvyW11akG5L3Z3FJSTEMm8NRS8vH10FlcpbOmXxnZbTHXMElc006HIeBjJz'
    :'pk_live_51LndsMJkFTRyFNmm05otlL9mNOYuRcFPkSZHUbCyHy98OIpeBG3LBU52emCaUPTMEU48QAURrzBnJg5XpmnPIaW000sixbdDyI';
  const stripePromise = loadStripe(pk);
  const options = {
    clientSecret: props.pics
  };
    
  return (
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}} >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Zahlung per Twint (alixon gmbh) / Kreditkarte</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.CloseModal}></button>
          </div>
          <div className="modal-body">
      {!window.Stripe? 
            <div>Die Online-Zahlung wurde auf deinem Computer gesperrt.<br />
            Begleiche deine Rechnung auf einem mobilen Gerät oder einem anderen Computer. <br />
            Du findest deine Rechnung oben rechts im Konto.</div>
      :  
            <Elements stripe={stripePromise} options={options}>
              <CheckoutForm {...props} />
            </Elements>
      }
          </div>
        </div>
      </div>
    </div>
  )
}

export default StripeForm;

/*
      <CardNumberElement className="form-control mb-1 mw-card" />
      <CardExpiryElement className="form-control mb-1 mw-card" />
      <CardCvcElement className="form-control mw-card" />
*/
